import { BREAKING_POINTS } from '../config';

export const isHamburgerNavigationOn = () =>
  window.innerWidth < BREAKING_POINTS.xl;
